<template>
  <div class="slider-area slider-style-three mt-5">
    <div class="row">
      <div class="d-none d-lg-block col-lg-3">
        <!--<?= $this->render('layouts/inc/test-catalog') ?>-->
      </div>
      <Loader v-if="!mainSliderVisible"></Loader>
      <div v-else class="col-md-12 col-lg-12 mb-5">
        <MainSlider></MainSlider>
      </div>
    </div>
  </div>

  <!-- Jumbotron -->
  <!--  <div class="card card-image mb-5" style="background-image: url(https://domstrousam.ru/wp-content/uploads/2020/10/234523452352352.jpg);">-->
  <!--    <div class="text-white text-center rgba-stylish-strong py-5 px-4">-->
  <!--      <div class="py-1">-->
  <!--        &lt;!&ndash; Content &ndash;&gt;-->
  <!--        <h2 class="card-title h2 my-4 py-1">На заказ от 500 рублей - доставка </h2>-->
  <!--        <h2 class="card-title h2 my-4 py-1">по городу Ставрополю </h2>-->
  <!--        <h2 class="card-title h2 my-4 py-1 text-success">БЕСПЛАТНАЯ!</h2>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->
  <!-- Jumbotron -->

  <!-- Jumbotron -->
  <div class="card card-image mb-5" style="background-image: url(https://prav-product.ru/img/charity/MyCollages.jpg);">
    <div class="text-white text-center rgba-stylish-strong py-5 px-4">
      <div class="py-5">
        <!-- Content -->
        <h2 class="card-title h2 my-4 py-2">Дорогие Благотворители!</h2>
        <h2 class="card-title h5 my-4 py-2">Благодарим всех Вас за чуткость и добросердечие в делах благотворительности к людям с ограниченными финансовыми возможностями. Вашими молитвами и помощью все больше нуждающихся людей получают теплоту Вашего сердца в виде пожертвований нашей молочной продукцией!</h2>
        <h2 class="card-title h5 my-4 py-2">Спасибо большое Вам за проявленный интерес к нашей социальной программе, которую проводит сайт «Православный продукт»! Многие и благая лета всем Вам!</h2>

        <!--        <h2 class="card-title h2 my-4 py-2 text-success">-->
        <!--          <a class="btn btn-success" href="https://prav-product.ru/post/8">Подробнее</a>-->
        <!--        </h2>-->

      </div>
    </div>
  </div>
  <!-- Jumbotron -->

  <!-- Jumbotron -->
  <div class="card card-image mb-5" style="background-image: url(https://avatars.mds.yandex.net/get-zen_doc/1654267/pub_5e275ee216ef9000ad85d1e4_5e4055f96e02892dc49dabb2/scale_1200);">
    <div class="text-white text-center rgba-stylish-strong py-5 px-4">
      <div class="py-1">
        <!-- Content -->
        <h2 class="card-title h2 my-4">Уважаемые покупатели!</h2>
        <h2 class="card-title h2 my-4">Интернет магазин "Православный продукт" временно не обслуживает своих клиентов.</h2>
        <h2 class="card-title h2 my-4">Приносим свои извинения. </h2>
        <h2 class="card-title h2 my-4">Нашу продукцию вы можете приобрести в торговых точках, указанных в разделе сайта
          <router-link @click.prevent="$scrollToTop" :to="{ name: 'Contact' }"
          > «Контакты».
          </router-link>
        </h2>
        <h2 class="card-title h2 my-4">Спасибо большое за понимание.</h2>
      </div>
    </div>
  </div>
  <!-- Jumbotron -->


  <div>
    <Loader v-if="!offersVisible"></Loader>
    <div v-else class="pb-5">
      <TitleBox title="Акции и скидки"></TitleBox>
      <div class="row">
        <ProductCard
          v-for="offer in OFFER_PRODUCTS"
          :key="offer.id"
          :product="offer"
          @addToCart="addToCart"
        ></ProductCard>
      </div>
    </div>

    <div class="embed-responsive embed-responsive-16by9">
      <iframe
        class="embed-responsive-item"
        src="https://www.youtube.com/embed/imfKNhdy9Ak"
        allowfullscreen
      ></iframe>
    </div>

    <div v-if="UPPER_BANNER_PRODUCTS" class="pt-5">
      <TitleBox title="Топ"></TitleBox>
      <div class="upper-banner banner">
        <div class="row">
          <UpperCard
            v-for="upper in UPPER_BANNER_PRODUCTS"
            :key="upper.id"
            :product="upper"
          ></UpperCard>
        </div>
      </div>
    </div>

    <div v-if="newProducts" class="pt-5">
      <TitleBox title="Новинки"></TitleBox>
      <splide :options="primaryOptions" ref="primary">
        <splide-slide v-for="slide in NEW_PRODUCTS" :key="slide.id">
          <NewProductsSliderTop :product="slide"></NewProductsSliderTop>
        </splide-slide>
        <template v-slot:controls>
          <div class="splide__progress mt-1">
            <div class="splide__progress__bar"></div>
          </div>
        </template>
      </splide>
      <splide :options="secondaryOptions" ref="secondary">
        <splide-slide v-for="slide in newProducts" :key="slide.id">
          <img
            :src="`../../../img/products/${slide.alias}/mini-${slide.id}.jpg`"
            :alt="slide.alias"
            style="object-fit: cover !important"
          />
        </splide-slide>
      </splide>
    </div>

    <div v-if="partnerProducts" class="pt-4">
      <TitleBox title="Продукция наших партнеров"></TitleBox>
      <div class="row">
        <ProductCard
          v-for="partnerProduct in partnerProducts"
          :key="partnerProduct.id"
          :product="partnerProduct"
          @addToCart="addToCart"
        ></ProductCard>
      </div>
    </div>

    <div class="pt-4">
      <TitleBox title="Сертификаты"></TitleBox>
      <Certificates></Certificates>
    </div>


    <div v-if="NEW_POSTS.length" class="pt-5">
      <TitleBox title="Наши новости"></TitleBox>
      <div class="row row-cols-1 row-cols-md-1">
        <div v-for="post in NEW_POSTS" :key="post.id" class="col mb-12 mb-20">
          <div class="card">
            <div class="row">
              <div class="overlay col-md-5">

                <img :data-src="`../../../img/blog/${post.categoryAlias}/${post.pub_date}/${post.alias}/1.jpg`"
                     :src="require(`/src/assets/img/loading.gif`)"
                     :alt="post.alias"
                     class="card-img-top bordered"
                />
              </div>
              <div class="card-body col-md-6">
                <h4 class="card-title">{{ post.title }}</h4>
                <p class="card-text">
                  <span>От: </span> <a href="#">{{ post.author }},</a>
                </p>
                <p class="card-text">
                  <span>Дата: </span> <a href="#">{{ post.pub_date }}</a>
                </p>
                <router-link
                  @click.prevent="$scrollToTop"
                  class="btn btn-warning"
                  :to="{
                    name: 'Post',
                    params: { id: post.id },
                  }"
                >Читать...
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-5">
      <TitleBox title="Отзывы"></TitleBox>
      <Reviews></Reviews>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import NewProductsSliderTop from "@/components/elements/NewProductsSliderTop";
import MainSlider from "@/components/elements/MainSlider";
import UpperCard from "@/components/elements/UpperCard";
import Certificates from "@/components/elements/Certificates";
import Reviews from "@/components/elements/Reviews";

export default {
  name: "Home",
  data() {
    return {
      loading: true,
      offersVisible: false,
      upperBanner: false,
      newProducts: false,
      partnerProducts: false,
      newPosts: false,
      mainSliderVisible: false,
      secondaryOptions: {
        type: "slide",
        rewind: true,
        gap: "1rem",
        pagination: false,
        fixedWidth: 110,
        fixedHeight: 80,
        cover: true,
        focus: "center",
        isNavigation: true,
        updateOnMove: true,
        lazyLoad: "nearby",
        arrows: false
      },
      primaryOptions: {
        type: "fade",
        rewind: true,
        perPage: 1,
        perMove: 1,
        gap: "1rem",
        pagination: false,
        autoplay: true,
        pauseOnHover: false,
        lazyLoad: "nearby",
        arrows: false
      },
      count: 0
    };
  },
  components: {
    NewProductsSliderTop,
    MainSlider,
    UpperCard,
    Certificates,
    Reviews
  },

  async created() {
    window.addEventListener("resize", this.checkScreen);
    this.checkScreen();
    // setTimeout(this.loadTime, 5000);
  },

  computed: {
    ...mapGetters({
      ALL_PRODUCTS: ["products/ALL_PRODUCTS"],
      OFFER_PRODUCTS: ["products/OFFER_PRODUCTS"],
      PARTNER_PRODUCTS: ["products/PARTNER_PRODUCTS"],
      UPPER_BANNER_PRODUCTS: ["products/UPPER_BANNER_PRODUCTS"],
      NEW_PRODUCTS: ["products/NEW_PRODUCTS"],
      NEW_POSTS: ["NEW_POSTS"]
    })
  },
  methods: {
    ...mapActions({
      ADD_TO_CART: "products/ADD_TO_CART"
    }),

    loadTime() {
      this.loading = false;
    },

    sync() {
      this.$refs.primary.sync(this.$refs.secondary.splide);
    },

    checkScreen() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 850) {
        this.mobile = true;
        return;
      }
      this.mobile = false;
    },

    addToCart(id) {
      this.ADD_TO_CART(id);
    }
  },
  mounted() {
    this.loading = true;
    this.newPosts = this.NEW_POSTS;
    this.newProducts = this.NEW_PRODUCTS;
    this.partnerProducts = this.PARTNER_PRODUCTS;
    setTimeout(this.sync, 1000);
    this.offersVisible = true;
    this.mainSliderVisible = true;
    // this.loading = false;
  }
};
</script>

<style lang="css" scoped>
.splide {
  padding: 0;
  padding-bottom: 20px;
}

.splide__progress__bar {
  background: #f5c90acc !important;
}

.splide--nav > .splide__track > .splide__list > .splide__slide.is-active {
  border-color: #f5c90acc;
  opacity: 1;
}
</style>
